import { CloseButton } from 'react-bootstrap';

type AppModalCloseButtonProps = {
  onClick: () => void;
  ariaLabel: string;
  title: string;
};

/** モーダルヘッダ用。aria は短いラベル、title は操作の全文。 */
export function AppModalCloseButton({
  onClick,
  ariaLabel,
  title,
}: AppModalCloseButtonProps) {
  return <CloseButton onClick={onClick} aria-label={ariaLabel} title={title} />;
}
